import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import MapEditor from 'components/ui/map/editor/MapEditor';
import { MODALS } from 'components/ui/redux/Actions';
import HeatMapConfDialog from 'components/ui/map/editor/HeatMapConfDialog';
import useFetchData from 'components/hooks/useFetchData';
import Api from 'components/Api';
import LoadingCenter from 'components/ui/loading/LoadingCenter';

const mapStateToProps = (state) => {
  return {
    id: state.newmap.id,
    source: state.newmap.source,
    cube: state.newmap.cube,
    openOnEditMode: state.newmap.openOnEditMode || state.newmap.id === 0,
    filter: state.newmap.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openHeatMapConf(params) {
      dispatch(MODALS.open(HeatMapConfDialog, params));
    },
  };
};

function MapEditorContainer(props) {
  const [searchParams] = useSearchParams();

  const { data: filters, isLoading } = useFetchData(async () => {
    if (props.filter) {
      return props.filter;
    }

    const filterRef = searchParams.get('filterRef');
    const result = await Api.TemporaryStorage.find(filterRef, false);
    return JSON.parse(result?.value ?? '[]');
  });

  if (isLoading) {
    return <LoadingCenter />;
  }

  return <MapEditor {...props} filter={filters} />;
}

export default connect(mapStateToProps, mapDispatchToProps)(MapEditorContainer);
